import React, { useState, FormEvent, useContext, useEffect, useCallback } from 'react';
import { Segment, Form, Button, Grid, Input, Table, Select, Image, Message, Container, Modal, Dimmer, GridColumnProps, Icon, Header } from 'semantic-ui-react';
import { ITechnicianCertificatePhoto } from '../../../app/models/techniciancertificatephoto';
import EmployeeStore from '../../../app/stores/employeeStore';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../../../app/stores/rootStore';
import { useDropzone } from 'react-dropzone';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { Link } from 'react-router-dom';
import CertificatePhotoDropzone from '../../../app/common/Dropzone/CertificatePhotoDropzone';

interface IProps {
  certificate: string;
  name: string;
  technicianEmail: string;
  certificateId: string;

}

const dropzoneStyles = {
  border: 'dashed 3px',
  borderColor: '#eee',
  borderRadius: '5px',
  paddingTop: '30px',
  textAlign: 'center' as 'center',
  height: '200px',
  width: '200px',
};

const dropzoneActive = {
  borderColor: 'green'
};

const EmployeeCertificatePhotoView: React.FC<IProps> = ({ certificate, name, technicianEmail, certificateId }) => {
  const rootStore = useContext(RootStoreContext);
  const {closeModal, openModal} = rootStore.modalStore;
  const employeeStore = useContext(EmployeeStore);
  const {
    loadTechnicianCertificatePhoto,
    techniciancertificatephotosById,
    deleteTechnicianCertificatePhoto,
    archiveTechnicianCertificate,
    target,
    submitting,
    uploadPhoto,
  } = employeeStore;

  const [active, setDimmer] = useState({
    gridid: '',
    status: false
  });

  const onDrop = useCallback(acceptedFiles => {
    uploadPhoto(acceptedFiles, certificate, name).then(()=> acceptedFiles.length = 0).then(
      ()=> loadTechnicianCertificatePhoto(technicianEmail, certificateId)
    ).
    then(() => openModal(<EmployeeCertificatePhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div>
      <Button
      onClick={() => archiveTechnicianCertificate(technicianEmail, certificateId).then(
        () => openModal(<EmployeeCertificatePhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>))}
      size='mini'
      icon="archive"
      content='Archive'
      floated='right'
      color="blue"
    /> 
    <Header content={certificate} />
    
          <Grid  columns='equal' style={{margin: 'auto'}} >
            { 
            // (techniciancertificatephotosById.length !== 0) ?
            techniciancertificatephotosById.map((techniciancertificatephoto) => (
               <Grid.Column key={techniciancertificatephoto.id}>
                 {techniciancertificatephoto.path.replace(/^.*[\\\/]/, '')}
      <Dimmer.Dimmable
      dimmed={active.status}
      onMouseEnter={() => setDimmer({['gridid']: techniciancertificatephoto.id, ['status']: true })}
      onMouseLeave={() => setDimmer({['gridid']: techniciancertificatephoto.id, ['status']: false })}
      >
      <Image src={(techniciancertificatephoto.url.split('.')[1].toUpperCase() === "JPG" || 
      techniciancertificatephoto.url.split('.')[1].toUpperCase() === "JPEG" ||
      techniciancertificatephoto.url.split('.')[1].toUpperCase() === "PNG") ? 
                    `${techniciancertificatephoto.url}` :
                   "/assets/placeholder.png"} size='medium'/>
      <Dimmer active={(active.gridid === techniciancertificatephoto.id) && active.status}>
      <Button
                   as="a"
                  href={`${techniciancertificatephoto.url}`}
                  target="_Blank"
                   size='mini'
                   content="Preview"
                   color="green"

                 />
    <Button
                   as="a"
                  href={`${techniciancertificatephoto.url}`}
                   download
                   size='mini'
                   content="Download"
                   color="blue"

                 />
                 <Button
                  name={techniciancertificatephoto.id}
                  loading={target === techniciancertificatephoto.id && submitting}
                  size='mini'
                  onClick={() =>  deleteTechnicianCertificatePhoto(techniciancertificatephoto.id).then(
                    () => openModal(<EmployeeCertificatePhotoView certificate={certificate} name={name} technicianEmail={technicianEmail} certificateId={certificateId}/>))}
                  color="red"
                  content="Delete"
                />
                 </Dimmer>
    </Dimmer.Dimmable>
    </Grid.Column>
            )) 
            // : 
            // <Message>No Certificate Photo Uploaded</Message>
           }
           <Grid.Column verticalAlign='middle'>
           <div
      {...getRootProps()}
      style={
        isDragActive ? { ...dropzoneStyles, ...dropzoneActive } : dropzoneStyles
      }
    >
      <input {...getInputProps()} />
      <Icon name='upload' size='huge' />
      <Header content='Drop image here or click' />
    </div>
           </Grid.Column>     
         </Grid>
    </div>
 
  );
};

export default EmployeeCertificatePhotoView;
